import { Card } from '@totalsoft/rocket-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';

function NotFound() {
  const { t } = useTranslation();

  return <Card>{t('PageNotFound')}</Card>;
}

export default NotFound;
